export { CardHistoryEntityMobile } from './card-history';
